import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "components/yenimahalle/Layout";
import PortalApi from "../../api/PortalApi";
import { GetTenderDetailResponse } from "../../models/Response/Portal";
import ContentHeader from "components/yenimahalle/ContentHeader";

const IhaleDetay: React.FC = () => {
  const { ihaleID } = useParams<{ ihaleID: string }>();
  const [tender, setTender] = useState<GetTenderDetailResponse | null>(null);
  const fetchTenders = async () => {
    const response = await PortalApi.getTenderDetail(Number(ihaleID));
    if (response) {
      setTender(response);
    }
  };

  useEffect(() => {
    if (ihaleID) {
      fetchTenders();
    }
  }, [ihaleID]);

  if (!tender) {
    return <div>Yükleniyor...</div>;
  }

  return (
    <Layout>

      <ContentHeader
        headingLine1={tender.tenderHeader}
        headingLine2=""
        topNotification=""
        bottomNotification={tender.tenderIntroText}
        primaryButtonUrl=""
        primaryButtonText=""
        secondaryButtonUrl=""
        secondaryButtonText=""
        photoUrl=""
        videoUrl=""
      />

      <div className="container">

        <div className="row text-center my-4">
          <div className="col-12 col-md-3 mb-3">
            <div className="p-3 card">
              <h6 className="mb-1">İhale Tarihi</h6>
              <p className="mb-0">{new Date(tender.tenderDate).toLocaleString("tr")}</p>
            </div>
          </div>
          <div className="col-12 col-md-3 mb-3">
            <div className="p-3 card">
              <h6 className="mb-1">Son Başvuru Tarihi</h6>
              <p className="mb-0">{new Date(tender.lastApplicationDate).toLocaleString("tr")}</p>
            </div>
          </div>
          <div className="col-12 col-md-3 mb-3">
            <div className="p-3 card">
              <h6 className="mb-1">Kayıt No</h6>
              <p className="mb-0">{tender.tenderRegisterNo}</p>
            </div>
          </div>
          <div className="col-12 col-md-3 mb-3">
            <div className="p-3 card">
              <h6 className="mb-1">İhalenin Yapılacağı Yer</h6>
              <p className="mb-0">{tender.tenderPlace}</p>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
            <div dangerouslySetInnerHTML={{ __html: tender.description }} />
          </div>
        </div>

      </div>

    </Layout >
  );
};

export default IhaleDetay;
